import { ChangeDetectorRef, Component } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RecordStatus } from '../../../entities/record-status.type';
import { GetFieldPipe } from '../../../pipes/get-field.pipe';
import { TextCellComponent } from '../text-cell/text-cell.component';

@Component({
    standalone: false,
    selector: 'digihaven-status-cell',
    templateUrl: './status-cell.component.html',
    styleUrls: ['./status-cell.component.scss']
})
export class StatusCellComponent extends TextCellComponent {
    className$: Observable<string>;

    constructor(fieldPipe: GetFieldPipe, cd: ChangeDetectorRef) {
        super(fieldPipe, cd);
        this.className$ = this.setupClassStream();
    }

    private setupClassStream(): Observable<string> {
        return this.data$.pipe(
            map(apiFragment => {
                switch (apiFragment.metadata.Administrative.RecordStatus) {
                    case RecordStatus.Rejected:
                        return 'sh-label--error';
                    default:
                        if (apiFragment.metadata.Administrative.HasFailedJobs) {
                            return 'sh-label--error';
                        }
                        return 'sh-label';
                }
            })
        );
    }
}
